import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { SessionService } from '../services/session.service';

export const sessionInterceptor: HttpInterceptorFn = (
  req,
  next
) => {
  const sessionService = inject(SessionService);
  const sessionId = sessionService.getSessionId();

  const isV2Endpoint = req.url.includes('/api/v2/');

  if (sessionId && isV2Endpoint) {
    req = req.clone({
      setHeaders: {
        Authorization: `Bearer ${sessionId}`
      }
    });
  }

  return next(req);
};
